import styled, { css } from 'styled-components';

import { device } from '@styles/mediaQuery';
import { Partners } from '@components/molecules';
import { CONTACTS } from '@shared/constants/contactUs';
import { Contact, ContactContent } from '@components/atoms';

function ChatWithUs() {
  const [email, phone] = CONTACTS;

  return (
    <Wrapper>
      <Content>
        <Contact title="Chat with us" description="Speak to our team via email">
          <ContactContent
            src={email.Icon}
            href={email.href}
            description={email.description}
            alt={email.alt}
            ariaLabel={email.ariaLabel}
          />
        </Contact>

        <Contact
          title="Call us if you have any questions!"
          description="Our support team is active 24/7"
        >
          <ContactContent
            src={phone.Icon}
            href={phone.href}
            description={phone.description}
            alt={phone.alt}
            ariaLabel={phone.ariaLabel}
          />
        </Contact>

        <Contact
          title="Trusted by 10,000+ companies"
          description="Greenline team is focused on being professional and safe."
        >
          <Partners />
        </Contact>
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 60px auto;
  max-width: 566px;

  ${device.laptopL(css`
    max-width: 490px;
    margin: 60px 40px;
    width: 35%;
  `)}
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default ChatWithUs;
